import { NAVIGATION_BADGE, NAVIGATION_BADGE_NO_BADGE } from './constants';

const navigationArmstrongTrackings = {
  supi: {
    sc_o: 'navigation_exchange',
    sc_o_PropActionOrigin: [
      'navigation_badge_exchange',
      NAVIGATION_BADGE_NO_BADGE,
    ],
  },
  messagesTopBar: {
    sc_o: 'navigation_messages',
    sc_o_PropActionOrigin: [
      'navigation_badge_messages',
      NAVIGATION_BADGE_NO_BADGE,
    ],
  },
  disco: {
    sc_o: 'navigation_discover',
    sc_o_PropActionOrigin: [NAVIGATION_BADGE, NAVIGATION_BADGE_NO_BADGE],
  },
  'me-hub': {
    sc_o: 'navigation_me',
    sc_o_PropActionOrigin: ['navigation_badge_me', NAVIGATION_BADGE_NO_BADGE],
  },
  premiumUpsellArmstrong: {
    reagent: 'uplt_747',
  },
  proJobsUpsellArmstrong: {
    reagent: 'uplt_748',
  },
  premiumArmstrong: {
    sc_o: 'navigation_premium',
    sc_o_PropActionOrigin: NAVIGATION_BADGE_NO_BADGE,
  },
  proJobsArmstrong: {
    sc_o: 'navigation_projobs',
    sc_o_PropActionOrigin: NAVIGATION_BADGE_NO_BADGE,
  },
  proBusinessArmstrong: {
    sc_o: 'navigation_probusiness',
    sc_o_PropActionOrigin: NAVIGATION_BADGE_NO_BADGE,
  },
  eventsArmstrong: {
    sc_o: 'navigation_events',
    sc_o_PropActionOrigin: [NAVIGATION_BADGE, NAVIGATION_BADGE_NO_BADGE],
  },
  contentArmstrong: {
    sc_o: 'navigation_news',
    sc_o_PropActionOrigin: NAVIGATION_BADGE_NO_BADGE,
  },
  groupsArmstrong: {
    sc_o: 'navigation_groups',
    sc_o_PropActionOrigin: NAVIGATION_BADGE_NO_BADGE,
  },
  feedbackInfoV2Armstrong: {
    sc_o: 'navigation_feedback_and_info',
    sc_o_PropActionOrigin: NAVIGATION_BADGE_NO_BADGE,
  },
};

export { navigationArmstrongTrackings };
